import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import TestEditorList from "./tests";
import Summary from "./summary";

import {Test, TestId} from "common/flowmaster/types/test";
import {WorkflowState} from "common/flowmaster/types/workflow_state";
import {LlmRunId, LlmRunTestResults} from "common/flowmaster/types/llm_run";
import {OrganisationId} from "common/types/organisation";

type Props = {
  llmRunId: LlmRunId;
  organisationId: OrganisationId;
  state: WorkflowState;
  tests: Test[];
  results?: LlmRunTestResults[];
  onClose: () => void;
  onAddTest: () => void;
  onUpdateTest: (
    id: TestId,
    type: string,
    value: Record<string, unknown>,
  ) => void;
  onDeleteTest: (id: TestId) => void;
};

export default function TestEditor({
  llmRunId,
  organisationId,
  state,
  tests,
  results,
  onClose,
  onAddTest,
  onUpdateTest,
  onDeleteTest,
}: Props) {
  return (
    <Dialog open={true}>
      <DialogTitle>Workflow Tests</DialogTitle>
      <Summary state={state} tests={tests} />
      <DialogContent>
        <TestEditorList
          llmRunId={llmRunId}
          organisationId={organisationId}
          tests={tests}
          results={results}
          onAddTest={onAddTest}
          onUpdateTest={onUpdateTest}
          onDeleteTest={onDeleteTest}
        />
        <DialogActions>
          <Button
            onClick={() => onAddTest()}
            color="primary"
            variant="contained"
          >
            Add
          </Button>
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
